import StateModel from "Compare/store/models/stateModel";

const state = new StateModel({
	products: new Array()
});
export { state };